import { Reducer } from "redux";

import { ServiceState } from "./serviceTypes";
import actionTypes from "../../redux/actionTypes";
export const initialState: ServiceState = {
  data: [],
  errors: undefined,
  loading: false,
};

const serviceReducer: Reducer<ServiceState> = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOAD_SERVICE_SUCCESS: {
      return { ...state, loading: false, data: action.payload };
    }
    case actionTypes.LOAD_SERVICE_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default serviceReducer;
